export default {
  type: 'noresult',
  aliases: ['noresult'],
  slices: [{
    name: 'tag_list_block',
    path: 'Global/TagListBlock.vue',
    additional: {
      query: 'categories',

      handler(arg) {
        return {
          hashes: arg.items.map(e => e.hash)
        };
      }

    }
  }, {
    name: 'rebounds',
    path: 'Global/Rebounds.vue'
  }]
};